import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { NavigationTrackerAuraService } from './navigation-tracker';

export const provideNavigationTracker = (): EnvironmentProviders =>
  makeEnvironmentProviders([
    provideAppInitializer(() => {
      inject(NavigationTrackerAuraService);
    }),
  ]);
